import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {Md5} from 'ts-md5/dist/md5';
import { PATTERNS } from "../../../../globals";

@Component({
  selector: 'login-signin',
  templateUrl: '../../templates/partials/signIn.html'
  
})
export class SignInComponent implements OnInit{

    @Output() loginState = new EventEmitter();
    @Output() loginData = new EventEmitter();
    public loginUser : FormGroup;
    @Input() loginError: boolean;

    constructor(private _fb: FormBuilder){}

    public changeLoginState(state){
        //this.state = 'recovery';
        this.loginState.emit(state);
    }

    public login(){
        if(this.loginUser.controls.email.valid && this.loginUser.controls.password.valid){
            let data: Object = {
                username: this.loginUser.controls.email.value,
                password: this.loginUser.controls.password.value,
            }
            this.loginData.emit(data);
        }else{
            //console.log("error");
            this.loginUser.controls['password'].setErrors({'incorrect': true});
        }
    }

    ngOnInit(){
        this.loginUser = this._fb.group({
            email: ['', [Validators.required, Validators.pattern(PATTERNS["email"])]],
            password: ['', [Validators.required,Validators.minLength(4)]]
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/login/components/dummy/signIn.component.ts